import { useMutation, useQueryClient } from 'react-query';

import useApiHelper from '../../../hooks/useApiHelper';

import { useDefaultMutateResponseHandlers } from '../../../hooks/useDefaultMutateResponeHandlers';
import {
  IFaultCause,
  IFaultCauseCreateRequest,
  IFaultCauseDeleteRequest,
} from '../../../types/Fault/FaultCause';
import { faultQueryKeys } from '../../QueryKeys';
import { IDefaultResponseWithData } from '../../../types/system/DefaultResponse';

export default function useSuperAdminFaultCauseMutations() {
  const queryClient = useQueryClient();
  const { post, put, del } = useApiHelper();
  const { handleSuccess, handleError } =
    useDefaultMutateResponseHandlers('Fault Cause');

  const createFaultCause = useMutation({
    mutationFn: (faultCause: IFaultCauseCreateRequest) =>
      post<IFaultCauseCreateRequest, IDefaultResponseWithData<IFaultCause>>(
        '/v1/superadmin/fault/causes',
        faultCause
      ),
    onError: (error) => handleError(error, 'create'),
    onSuccess: (data) => handleSuccess(data, 'create'),
    onSettled: () =>
      queryClient.invalidateQueries(faultQueryKeys.superAdminCauses()),
  });

  const updateFaultCause = useMutation({
    mutationFn: (faultCause: IFaultCause) =>
      put<IFaultCause>(
        `/v1/superadmin/fault/causes/${faultCause.id}`,
        faultCause
      ),
    onError: (error) => handleError(error, 'update'),
    onSuccess: (data) => handleSuccess(data, 'update'),
    onSettled: () =>
      queryClient.invalidateQueries(faultQueryKeys.superAdminCauses()),
  });

  const delFaultCause = useMutation({
    mutationFn: (faultCause: IFaultCauseDeleteRequest) =>
      del(`/v1/superadmin/fault/causes/${faultCause.id}`),
    onError: (error) => handleError(error, 'delete'),
    onSuccess: (data) => handleSuccess(data, 'delete'),
    onSettled: () =>
      queryClient.invalidateQueries(faultQueryKeys.superAdminCauses()),
  });

  return {
    createFaultCause,
    updateFaultCause,
    delFaultCause,
  };
}
